import { faFaceAwesome } from '@fortawesome/pro-solid-svg-icons'

import { LinkButton } from 'Components/_theme'

import { Heading } from '../Heading/Heading'

export const LinkButtonPresentation = () => (
  <div>
    <Heading size={4}>Primary Dark Link Buttons:</Heading>
    <Heading size={5}>Medium: </Heading>

    <div className="d-flex pt-4 justify-content-evenly">
      {/* ***  Primary Link Button Medium Dark *** */}

      <LinkButton size="medium" to="#">
        LinkM Button
      </LinkButton>

      {/* ***  Primary Link Button Medium Dark icon Lef *** */}

      <LinkButton iconLeft={faFaceAwesome} size="medium" to="#">
        LinkM Button
      </LinkButton>

      {/* ***  Primary Link Button Medium Dark icon Right *** */}

      <LinkButton iconRight={faFaceAwesome} size="medium" to="#">
        LinkM Button
      </LinkButton>

      {/* ***  Primary Link Button Medium Dark icon Both *** */}

      <LinkButton
        iconLeft={faFaceAwesome}
        iconRight={faFaceAwesome}
        size="medium"
        to="#"
      >
        LinkM Button
      </LinkButton>
    </div>

    <div className="d-flex pt-4 justify-content-evenly">
      {/* *** Primary Link Button Medium Dark Disabled *** */}

      <LinkButton disabled size="medium" to="#">
        LinkM Button
      </LinkButton>

      {/* *** Primary Link Button Medium Dark Disabled icon Left *** */}

      <LinkButton disabled iconLeft={faFaceAwesome} size="medium" to="#">
        LinkM Button
      </LinkButton>

      {/* *** Primary Link Button Medium Dark Disabled icon Right *** */}

      <LinkButton disabled iconRight={faFaceAwesome} size="medium" to="#">
        LinkM Button
      </LinkButton>

      {/* *** Primary Link Button Medium Dark Disabled icon Both *** */}

      <LinkButton
        disabled
        iconLeft={faFaceAwesome}
        iconRight={faFaceAwesome}
        size="medium"
        to="#"
      >
        LinkM Button
      </LinkButton>
    </div>

    <Heading size={5}>Large: </Heading>

    <div className="d-flex pt-4 justify-content-evenly">
      {/* *** Primary Link Button Large Dark *** */}

      <LinkButton size="large" to="#">
        LinkL Button
      </LinkButton>

      {/* *** Primary Link Button Large Dark icon Left *** */}

      <LinkButton iconLeft={faFaceAwesome} size="large" to="#">
        LinkL Button
      </LinkButton>

      {/* *** Primary Link Button Large Dark icon Right *** */}

      <LinkButton iconRight={faFaceAwesome} size="large" to="#">
        LinkL Button
      </LinkButton>

      {/* *** Primary Link Button Large Dark icon Both *** */}

      <LinkButton
        iconLeft={faFaceAwesome}
        iconRight={faFaceAwesome}
        size="large"
        to="#"
      >
        LinkL Button
      </LinkButton>
    </div>

    <div className="d-flex pt-4 justify-content-evenly">
      {/* *** Primary Link Button Large Dark Disabled *** */}

      <LinkButton disabled size="large" to="#">
        LinkL Button
      </LinkButton>

      {/* *** Primary Link Button Large Dark Disabled icon Left *** */}

      <LinkButton disabled iconLeft={faFaceAwesome} size="large" to="#">
        LinkL Button
      </LinkButton>

      {/* *** Primary Link Button Large Dark Disabled icon Right *** */}

      <LinkButton disabled iconRight={faFaceAwesome} size="large" to="#">
        LinkL Button
      </LinkButton>

      {/* *** Primary Link Button Large Dark Disabled icon Both *** */}

      <LinkButton
        disabled
        iconLeft={faFaceAwesome}
        iconRight={faFaceAwesome}
        size="large"
        to="#"
      >
        LinkL Button
      </LinkButton>
    </div>

    <Heading size={5}>Small: </Heading>

    <div className="d-flex pt-4 justify-content-evenly">
      {/* *** Primary Link Button Small Dark *** */}

      <LinkButton size="small" to="#">
        LinkS Button
      </LinkButton>

      {/* *** Primary Link Button Small Dark icon Left *** */}

      <LinkButton iconLeft={faFaceAwesome} size="small" to="#">
        LinkS Button
      </LinkButton>

      {/* *** Primary Link Button Small Dark icon Right *** */}

      <LinkButton iconRight={faFaceAwesome} size="small" to="#">
        LinkS Button
      </LinkButton>

      {/* *** Primary Link Button Small Dark icon Both *** */}

      <LinkButton
        iconLeft={faFaceAwesome}
        iconRight={faFaceAwesome}
        size="small"
        to="#"
      >
        LinkS Button
      </LinkButton>
    </div>

    <div className="d-flex pt-4 justify-content-evenly">
      {/* *** Primary Link Button Small Dark Disabled *** */}

      <LinkButton disabled size="small" to="#">
        LinkS Button
      </LinkButton>

      {/* *** Primary Link Button Small Dark Disabled icon Left *** */}

      <LinkButton disabled iconLeft={faFaceAwesome} size="small" to="#">
        LinkS Button
      </LinkButton>

      {/* *** Primary Link Button Small Dark Disabled icon Right *** */}

      <LinkButton disabled iconRight={faFaceAwesome} size="small" to="#">
        LinkS Button
      </LinkButton>

      {/* *** Primary Link Button Small Dark Disabled icon Both *** */}

      <LinkButton
        disabled
        iconLeft={faFaceAwesome}
        iconRight={faFaceAwesome}
        size="small"
        to="#"
      >
        LinkS Button
      </LinkButton>
    </div>

    <Heading className="pb-4" size={4}>
      Light Link Buttons:
    </Heading>

    <div className="darkbg-presentation">
      <Heading size={4}>Medium:</Heading>

      <div className="d-flex pt-4 justify-content-evenly">
        {/* *** Light Link Button Medium *** */}

        <LinkButton size="medium" to="#" variant="light">
          LinkM Button
        </LinkButton>

        {/* *** Light Link Button Medium icon Left *** */}

        <LinkButton
          iconLeft={faFaceAwesome}
          size="medium"
          to="#"
          variant="light"
        >
          LinkM Button
        </LinkButton>

        {/* *** Light Link Button Medium icon Right *** */}

        <LinkButton
          iconRight={faFaceAwesome}
          size="medium"
          to="#"
          variant="light"
        >
          LinkM Button
        </LinkButton>

        {/* *** Light Link Button Medium icon Both *** */}

        <LinkButton
          iconLeft={faFaceAwesome}
          iconRight={faFaceAwesome}
          size="medium"
          to="#"
          variant="light"
        >
          LinkM Button
        </LinkButton>
      </div>

      <div className="d-flex pt-4 justify-content-evenly">
        {/* *** Light Link Button Medium Disabled *** */}

        <LinkButton disabled size="medium" to="#">
          LinkM Button
        </LinkButton>

        {/* *** Light Link Button Medium Disabled icon Left *** */}

        <LinkButton disabled iconLeft={faFaceAwesome} size="medium" to="#">
          LinkM Button
        </LinkButton>

        {/* *** Light Link Button Medium Disabled icon Right *** */}

        <LinkButton disabled iconRight={faFaceAwesome} size="medium" to="#">
          LinkM Button
        </LinkButton>

        {/* *** Light Link Button Medium Disabled icon Both *** */}

        <LinkButton
          disabled
          iconLeft={faFaceAwesome}
          iconRight={faFaceAwesome}
          size="medium"
          to="#"
        >
          LinkM Button
        </LinkButton>
      </div>

      <Heading size={4}>Large:</Heading>

      <div className="d-flex pt-4 justify-content-evenly">
        {/* *** Light Link Button Large *** */}

        <LinkButton size="large" to="#" variant="light">
          LinkL Button
        </LinkButton>

        {/* *** Light Link Button Large icon Left *** */}

        <LinkButton
          iconLeft={faFaceAwesome}
          size="large"
          to="#"
          variant="light"
        >
          LinkL Button
        </LinkButton>

        {/* *** Light Link Button Large icon Right *** */}

        <LinkButton
          iconRight={faFaceAwesome}
          size="large"
          to="#"
          variant="light"
        >
          LinkL Button
        </LinkButton>

        {/* *** Light Link Button Large icon Both *** */}

        <LinkButton
          iconLeft={faFaceAwesome}
          iconRight={faFaceAwesome}
          size="large"
          to="#"
          variant="light"
        >
          LinkL Button
        </LinkButton>
      </div>

      <div className="d-flex pt-4 justify-content-evenly">
        {/* *** Light Link Button Large Disabled *** */}

        <LinkButton disabled size="large" to="#">
          LinkL Button
        </LinkButton>

        {/* *** Light Link Button Large Disabled icon Left *** */}

        <LinkButton disabled iconLeft={faFaceAwesome} size="large" to="#">
          LinkL Button
        </LinkButton>

        {/* *** Light Link Button Large Disabled icon Right *** */}

        <LinkButton disabled iconRight={faFaceAwesome} size="large" to="#">
          LinkL Button
        </LinkButton>

        {/* *** Light Link Button Large Disabled icon Both *** */}

        <LinkButton
          disabled
          iconLeft={faFaceAwesome}
          iconRight={faFaceAwesome}
          size="large"
          to="#"
        >
          LinkL Button
        </LinkButton>
      </div>

      <Heading size={4}> Small:</Heading>

      <div className="d-flex pt-4 justify-content-evenly">
        {/* *** Light Link Button Small *** */}

        <LinkButton size="small" to="#" variant="light">
          LinkS Button
        </LinkButton>

        {/* *** Light Link Button Small icon Left *** */}

        <LinkButton
          iconLeft={faFaceAwesome}
          size="small"
          to="#"
          variant="light"
        >
          LinkS Button
        </LinkButton>

        {/* *** Light Link Button Small icon Right *** */}

        <LinkButton
          iconRight={faFaceAwesome}
          size="small"
          to="#"
          variant="light"
        >
          LinkS Button
        </LinkButton>

        {/* *** Light Link Button Small icon Both *** */}

        <LinkButton
          iconLeft={faFaceAwesome}
          iconRight={faFaceAwesome}
          size="small"
          to="#"
          variant="light"
        >
          LinkS Button
        </LinkButton>
      </div>

      <div className="d-flex pt-4 justify-content-evenly">
        {/* *** Light Link Button Small Disabled *** */}

        <LinkButton disabled size="small" to="#">
          LinkS Button
        </LinkButton>

        {/* *** Light Link Button Small Disabled iocn Left *** */}

        <LinkButton disabled iconLeft={faFaceAwesome} size="small" to="#">
          LinkS Button
        </LinkButton>

        {/* *** Light Link Button Small Disabled iocn Right *** */}

        <LinkButton disabled iconRight={faFaceAwesome} size="small" to="#">
          LinkS Button
        </LinkButton>

        {/* *** Light Link Button Small Disabled iocn Both *** */}

        <LinkButton
          disabled
          iconLeft={faFaceAwesome}
          iconRight={faFaceAwesome}
          size="small"
          to="#"
        >
          LinkS Button
        </LinkButton>
      </div>
    </div>
  </div>
)
